import { useEffect, useRef, useState } from "react";
import { wsUrl } from "@/lib/api";

export function useWebSocket(onMessage) {
    const [connected, setConnected] = useState(false);
    const wsRef = useRef(null);
    const reconnectRef = useRef(null);

    useEffect(() => {
        let mounted = true;
        const connect = () => {
            try {
                const ws = new WebSocket(wsUrl());
                wsRef.current = ws;
                ws.onopen = () => {
                    if (!mounted) return;
                    setConnected(true);
                };
                ws.onmessage = (ev) => {
                    try {
                        const data = JSON.parse(ev.data);
                        if (onMessage) onMessage(data);
                    } catch (_) {}
                };
                ws.onerror = () => setConnected(false);
                ws.onclose = () => {
                    setConnected(false);
                    if (mounted) {
                        reconnectRef.current = setTimeout(connect, 3000);
                    }
                };
            } catch (_) {
                reconnectRef.current = setTimeout(connect, 3000);
            }
        };
        connect();
        return () => {
            mounted = false;
            if (reconnectRef.current) clearTimeout(reconnectRef.current);
            if (wsRef.current) wsRef.current.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { connected };
}
